




































import {
  Component,
  Prop,
  Vue,
  Watch
} from 'vue-property-decorator'
import {
  getPanelGroupCounts
} from '@/api/statistics'
import { hasPermission, hasRoles } from '@/utils'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'PanelGroup'
})

export default class extends Vue {
  @Prop({ required: true }) private range!: any
  @Prop({ required: false }) private userId!: any
  private chartData = {}
  private groups = [{
    class: 'icon-people',
    icon: 'el-icon-user',
    label: 'collaborators',
    key: 'users_count',
    disabled: !this.showPanel(['VIEW_USERS']),
    callback: () => {
      return this.$router.push({
        path: '/user/list',
        query: {
          active: "true"
        }
      })
    }
  }, {
    class: 'icon-message',
    icon: 'el-icon-message',
    label: 'properties',
    key: 'properties_count',
    disabled: !this.showPanel(['VIEW_PROPERTIES']),
    callback: () => {
      return this.$router.push({
        path: '/property/list',
        query: {
          status: 'approved',
          assignation_state: [
            'active',
            'under_negotiation',
            'under_offer_status'
          ]
        }
      })
    }
  }, {
    class: 'icon-money',
    icon: 'el-icon-money',
    label: 'searches',
    key: 'searches_count',
    disabled: !this.showPanel(['VIEW_SEARCHES']),
    callback: () => {
      return this.$router.push({
        path: '/search/list',
        query: {
          active: "true"
        }
      })
    }
  }, {
    class: 'icon-shopping',
    icon: 'el-icon-shopping-cart-full',
    label: 'clients',
    key: 'clients_count',
    disabled: !this.showPanel(['VIEW_CLIENTS']),
    callback: () => {
      return this.$router.push({
        path: '/client/list',
        query: {
          ...this.range
        }
      })
    }
  }, {
    class: 'icon-shopping',
    icon: 'el-icon-call',
    label: 'propertiesForApproval',
    key: 'properties_for_approval_count',
    disabled: !this.showPanel(['APPROVE_PROPERTIES', 'LIST_OTHERS_PROPERTIES']),
    callback: () => {
      return this.$router.push({
        path: '/property/list',
        query: {
          status: 'sent_for_approval'
        }
      })
    }
  }, {
    class: 'icon-shopping',
    icon: 'el-icon-ext-call',
    label: 'incomingCalls',
    key: 'calls_count',
    disabled: !this.showPanel(['VIEW_CALLS']),
    callback: () => {
      return this.$router.push({
        path: '/call/list',
        query: {
          ...this.range
        }
      })
    }
  }, {
    class: 'icon-shopping',
    icon: 'el-icon-shopping-cart-full-properties',
    label: 'searches_with_new_properties_count',
    key: 'searches_with_new_properties_count',
    disabled: !this.showPanel(['VIEW_SEARCHES']),
    callback: () => {
      return this.$router.push({
        path: '/search/list',
        query: {
          only_new_properties: 'true'
        }
      })
    }
  }, {
    class: 'icon-shopping',
    icon: 'el-icon-partnership',
    label: 'collaborations',
    key: 'collaborations_count',
    disabled: !this.showPanel(['VIEW_COLLABORATIONS']),
    callback: () => {
      console.log('nowhere to go')
    }
  }, {
    class: 'icon-shopping',
    icon: 'el-icon-recommendations',
    label: 'recommendations',
    key: 'recommendations_count',
    disabled: !this.showPanel(['VIEW_RECOMMENDATIONS']),
    callback: () => {
      console.log('nowhere to go')
    }
  }]

  @Watch('range', { deep: true })
  private onRangeChange() {
    this.fetchResults()
  }

  private async fetchResults() {
    const { data } = await getPanelGroupCounts({
      range: this.range,
      userId: this.userId || null
    })
    this.chartData = data
  }

  private showPanel(privileges: any) {
    return hasRoles(['super_admin'], UserModule.roles) || hasPermission(privileges)
  }

  created() {
    this.fetchResults()
  }
}
